import React from "react";
import DetalhesMatrizRiscos from "./DetalhesMatrizRiscos";

export default function CadastroMatrizRiscos() {
  return <DetalhesMatrizRiscos />;
}
